import { Injectable } from "@angular/core";
import { EventEmitter } from "@angular/core";
import { AcessoApiService } from '../../../acessoApi.service'
import { error } from "util";
import { NotificationsService } from 'angular2-notifications';
import { CategoriaModel } from './categoria.model'
import { Router } from '@angular/router'


@Injectable()
export class CategoriaAtendimentoService{

    constructor(private acessoAPI: AcessoApiService, private notificacao: NotificationsService, private routes: Router ){}
public codCat: any;
public mensagem: any
public arrayInfos: any

emitirNovaCategoria = new EventEmitter();


    setCodCat(codCat: number): void{
        this.codCat = codCat
    }




    recuperarCodCat(): any{
        return this.codCat;
    }


    excluirCodCat(): any{
        this.acessoAPI.excluirCategoria(this.codCat).subscribe( data => {

            this.notificacao.success(
                'Solicitação enviada!',
                'Categoria excluida com sucesso',
                {
                  timeOut: 2000,
                  showProgressBar: false,
                  pauseOnHover: false,
                  clickToClose: false,
                  maxLength: 2
                }
              )

        },error =>{

            this.notificacao.error(
                'Solicitação não enviada!',
                error._body,
                {
                  timeOut: 2000,
                  showProgressBar: false,
                  pauseOnHover: false,
                  clickToClose: false,
                  maxLength: 2
                }
              )
        })
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/administracao/categoria-atendimento/categoriaAtendimento.service.ts